import { FC } from "react";
import { IconProps } from "./types";

export const CaretRightSolid: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M17 12 7 4v16l10-8z"
      fill={fill}
    />
  </svg>
);
